module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_G170205.d207f47f.png";